import {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
    getContractsDetails,
    getIntegrationContracts,
    getSubscriptionPackages,
} from 'src/openapi/admin/apis/ContractControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import {ConcurrentStrategies} from '@pb/middleware-api';


import {getAccountId} from '../../../../services/selectors';
import {crmIntegrationSelector} from '../../setup/services/selectors';
import {clearContracts} from '../services/actions';
import {requiredContractsRefreshSelector} from '../services/selectors';

export const usePricingSubscriptions = () => {
    const dispatch = useDispatch();
    const apiDispatch = useAppDispatch();
    const accountId = useSelector(getAccountId);

    const refreshRequired = useSelector(requiredContractsRefreshSelector);
    const crmIntegration = useSelector(crmIntegrationSelector);

    useEffect(() => {
        if (!crmIntegration && accountId) {
            apiDispatch(getSubscriptionPackages({accountId}));
        }
    }, [crmIntegration, accountId, apiDispatch]);

    const loadContracts = useCallback(() => {
        if (accountId) {
            if (crmIntegration) {
                apiDispatch(getIntegrationContracts({accountId}, {concurrentStrategy: ConcurrentStrategies.LAST}));
            } else {
                apiDispatch(getContractsDetails({accountId}, {concurrentStrategy: ConcurrentStrategies.LAST}));
            }
        }
    }, [crmIntegration, accountId, apiDispatch]);

    useEffect(() => {
        if (refreshRequired) {
            loadContracts();
        }
    }, [refreshRequired, loadContracts]);

    useEffect(() => {
        if (accountId) {
            loadContracts();
        }

        return () => {
            dispatch(clearContracts());
        };
    }, [accountId, loadContracts, dispatch]);
};
